import { getCurrentTimeInMinutes, getTodayDate } from './dateUtils';

export const formatDuration = (minutes) => {
    if (!minutes && minutes !== 0) return "";
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hrs === 0) {
        return `${mins}min`;
    }
    return `${hrs}hr ${mins}min`;
};

export const truncateText = (text, length) => {
    if (!text) return "";
    return text.length > length ? text.substring(0, length) + "..." : text;
};

export const filterFutureMovies = (movies) => {
    const currentTimeInMinutes = getCurrentTimeInMinutes();
    const today = getTodayDate();

    return movies.filter((movie) => {
        if (!movie.showtimes || movie.showtimes.length === 0) return false;

        return movie.showtimes.some((showtime) => {
            if (!showtime.date || !showtime.start_time) return false;

            if (showtime.date === today) {
                const [hour, minute] = showtime.start_time.split(":").map(Number);
                const showtimeInMinutes = hour * 60 + minute;
                return showtimeInMinutes > currentTimeInMinutes;
            }
            return showtime.date > today;
        });
    });
};

export const getUniqueShowtimes = (showtimes, cinemaName) => {
    const currentTimeInMinutes = getCurrentTimeInMinutes();
    const today = getTodayDate();

    return showtimes
        .filter((showtime) => {
            if (showtime.cinema_name !== cinemaName) return false;

            if (showtime.date === today) {
                const [hour, minute] = showtime.start_time.split(":").map(Number);
                const showtimeInMinutes = hour * 60 + minute;
                return showtimeInMinutes > currentTimeInMinutes;
            }
            return true;
        })
        .map((showtime) => showtime.start_time.slice(0, 5));
};
